import React, { Component } from 'react';
import Button from '@dbk/ui-buttons';
import { FormGroup, TextInput, Label, Message } from '@dbk/ui-forms';
import Dropdown from '@dbk/ui-dropdowns';
import { createContainer } from '@dbk-legacy/muster/react';
import { CountryList } from './country-list';
import { checkDuplicateContact } from './mcd-common';
import DuplicateContactModal from './duplicate-contact-modal'
import { ROUTES, HRMW_CONSTANTS, HRMW_DROPDOWN_CONSTANTS } from '../../../constants';
import '../../../../src/assets/styles/hrmw-mcd.scss';

class AddContactDetails extends Component {
	constructor(props) {
		super(props);
		this.state = ({
			email: '',
			fax: '',
			isValidEmail: true,
			isValidFax: true,
			isValidPhone: true,
			isValidPhoneType: true,
			selectedPersonId: '',
			isPersonSelected: true,
			selectedPhoneCountry: '',
			selectedFaxCountry: '',
			isValidPhoneCountry: true,
			selectPhoneType: '',
			phoneNo: '',
			isValidFaxCountry: true,
			showDuplicateModal: false,
			dupIndex: -1,
			countryList: CountryList(),
			mobileNumberTypeValues: HRMW_DROPDOWN_CONSTANTS
		});
	}

	componentDidMount = () => {
		this.props.hrmw.setIsAddContactDetailsFlow(true);
	}

	cancelAddContactDetail = () => {
		this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
	}

	onCloseDuplicateModal = () => {
		this.setState({showDuplicateModal: false});
	}
	validateContactDetails = async () => {

		const { email, fax, selectedPersonId, phoneNo, selectedPhoneCountry, selectPhoneType, selectedFaxCountry } = this.state;

		if (!this.isValidationError()) {
			let obj = {};
			if (email) {
				obj.emailId = email;
			}
			if (fax) {
				obj.fax = fax;
				obj.faxCountryCode = selectedFaxCountry;
			}
			if(phoneNo) {
				obj.phoneNo = phoneNo;
				obj.countryCode = selectedPhoneCountry;
				obj.phoneType = selectPhoneType;
			}
			obj.personId = selectedPersonId;
			const contactCheckIndex = checkDuplicateContact(obj, this.props.hrmw.latestContactDetails);
			if(contactCheckIndex == -1) {
				await this.props.hrmw.setNewContactDetails(obj);
				await this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
			} else {
				this.setState({dupIndex: contactCheckIndex}, () => {
					this.setState({showDuplicateModal: true});
				});
			}
		} else {
			// validation error message to be display here
		}

	}

	isValidationError = () => {
		const { email, fax, selectedPersonId, selectedPhoneCountry, phoneNo, selectPhoneType, selectedFaxCountry } = this.state;

		let isError = false;
		// if no person selected
		if (selectedPersonId === '') {
			this.setState({ isPersonSelected: false });
			isError = true;
		} else {
			this.setState({ isPersonSelected: true });
		}

		// if nothing is updated
		if( !email && !fax && !selectedFaxCountry && !selectedPhoneCountry && !phoneNo && !selectPhoneType) {
			isError = true;
		}

		// check email
		if (email) {
			if (!this.validateEmail()) {
				isError = true;
			}
		}

		// check fax
		if (fax || selectedFaxCountry) {
			if(!selectedFaxCountry) {
				isError = true;
				this.setState({isValidFaxCountry: false});
			} else {
				if (!this.validateFax()) {
					isError = true;
				}
				if(!this.validateFaxCountry()) {
					isError = true;
				}
			}
		}

		// phone Number Validation
		if (selectedPhoneCountry || phoneNo || selectPhoneType) {
			if(phoneNo) {
				if(!this.validatePhoneNo()) {
					isError = true;
				}
			} else {
				this.setState({ isValidPhone: false });
				isError = true;
			}
			if(!selectPhoneType) {
				this.setState({isValidPhoneType: false});
				isError = true;
			} else {
				this.setState({isValidPhoneType: true});
			}
			if(!selectedPhoneCountry) {
				this.setState({isValidPhoneCountry: false});
				isError = true;
			} else {
				this.setState({isValidPhoneCountry: true});
			}
		} else {
			this.setState({
				isValidPhone: true,
				isValidPhoneCountry: true,
				isValidPhoneType: true
			});
		}

		return isError;
	}

	validatePhoneNo = () => {
		const { phoneNo } = this.state;
		const phoneNoRegEx = HRMW_CONSTANTS.PHONE_NO_REG_EX;
		const isValid = phoneNoRegEx.test(phoneNo);
		if (isValid) {
			this.setState({ isValidPhone: true });
		} else {
			this.setState({ isValidPhone: false });
		}
		return isValid;
	}

	saveEmail = (event) => {
		this.setState({
			email: event.target.value
		});
	}

	validateEmail = () => {
		const { email } = this.state;
		if (email.length != 0) {
			const emailRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			const isValid = emailRegEx.test(email);
			if (isValid) {
				this.setState({ isValidEmail: true });
			} else {
				this.setState({ isValidEmail: false });
			}
			return isValid;
		} else {
			return false;
		}
	}

	saveFax = (event) => {
		this.setState({
			fax: event.target.value
		}, () => {
			this.validateFax();
		});
	}

	savePhoneNo = (event) => {
		this.setState({
			phoneNo: event.target.value
		});
	}

	validateFax = () => {
		const { fax } = this.state;
		if (fax.length != 0) {
			const faxRegEx = HRMW_CONSTANTS.FAX_REG_EX;
			const isValid = faxRegEx.test(this.state.fax);
			if (isValid) {
				this.setState({ isValidFax: true });
			} else {
				this.setState({ isValidFax: false });
			}
			return isValid;
		} else if(this.state.selectedFaxCountry) {
			this.setState({ isValidFax: false });
			return false;
		} else {
			this.setState({ isValidFax: true });
			return true;
		}
	}

	validateFaxCountry = () => {
		const { selectedFaxCountry } = this.state;
		if( selectedFaxCountry == '') {
			this.setState({isValidFaxCountry: false});
			return false;
		} else {
			this.setState({isValidFaxCountry: true});
			return true;
		}
	}

	changePerson = (person) => {
		this.setState({ selectedPersonId: person });
	}

	selectPhoneCountry = (selectedCountry) => {
		this.setState({selectedPhoneCountry: selectedCountry});
	}

	selectFaxCountry = (faxCountry) => {
		this.setState({selectedFaxCountry: faxCountry});
	}
	selectPhoneType = (selectedPhoneType) => {
		this.setState({selectPhoneType: selectedPhoneType});
	}

	render() {
		const { i18n: { messages }, hrmw: { contactDetailsPersonData } } = this.props;
		const { isValidEmail, isValidFax, selectedPersonId, isPersonSelected, mobileNumberTypeValues, selectPhoneType, isValidPhone, isValidPhoneType, isValidPhoneCountry, isValidFaxCountry, countryList, showDuplicateModal } = this.state;
		let personDropdownValues = [];

		_.forEach(contactDetailsPersonData, function (value) {
			let label;
			if (value.name) {
				label = value.name;
			} else {
				label = `${value.firstName} ${value.middleName} ${value.lastName}`;
			}
			personDropdownValues.push({
				value: value.personId,
				label: label
			});
		});

		if (showDuplicateModal) {
			return <DuplicateContactModal onCloseDuplicateModal={this.onCloseDuplicateModal} dupIndex={this.state.dupIndex} />
		}

		const isInputFieldsEmpty = !this.state.email && !this.state.phoneNo && !this.state.fax;

		return (

			<div className="small-12 medium-12 large-12">
				<h1>{messages['app.common.pageTitle.manageContactDetails']}</h1>
				<div className="addContactGrid">
					<div className="small-12 medium-10 large-10 large-centered">
						<h3>{messages['app.manageContactDetails.fillDetailsInstruction']}</h3>
						<div className="headerMargin">
							<FormGroup>
								<Label>{messages['app.manageContactDetails.filter.email']}</Label>
								<TextInput
									testID='txt-email-test'
									placeholder={messages['app.manageContactDetails.addContact.emailPlaceholder']}
									type="text"
									value={this.state.email}
									onChange={(e) => this.saveEmail(e)}
								/>
								{!isValidEmail && (<Message type="error">{messages['app.manageContactDetails.addContact.emailValidation.emailInvalid']}</Message>)}

							</FormGroup>
						</div>
						<div className="row">
							<div className="small-12 medium-7 large-7">
								<FormGroup>
									<Label>{messages['app.manageContactDetails.addContact.phoneNumber']}</Label>
								</FormGroup>
							</div>
						</div>

						<div className="row">
							<div className="small-12 medium-5 large-5 column zeroLeftPadding">
								<Dropdown
									className ='dropdownColor'
									fullWidth
									onChange={(e) => this.selectPhoneCountry(e)}
									selected = {this.state.selectedPhoneCountry}
									options={countryList}
								/>
								{!isValidPhoneCountry && <Message type="error">{messages['app.payments.dropdown.select']}</Message>}
							</div>
							<div className="small-12 medium-4 large-4 column zeroRightPadding">
								<TextInput
									textID="mobile_number"
									testID='txt-mobile-no-test'
									placeholder={messages['app.manageContactDetails.addContact.mobileNumberPlaceholder']}
									type="text"
									value={this.state.phoneNo}
									onChange={(e) => this.savePhoneNo(e)}
								/>
								{!isValidPhone && <Message type="error">{messages['app.manageContactDetails.addContact.phoneValidation.phoneNoInvalid']}</Message>}
							</div>
							<div className="small-12 medium-3 large-3 column zeroRightPadding">
								<FormGroup>
									<Dropdown
										fullWidth
										className ='dropdownColor'
										textID="mobile_type"
										testID='mobile-number-type'
										defaultLabel={messages['app.manageContactDetails.addContact.mobileNumberTyppePlaceholder']}
										onChange={(e) => this.selectPhoneType(e)}
										selected={selectPhoneType}
										options={mobileNumberTypeValues}
									/>
									{!isValidPhoneType && <Message type="error">{messages['app.manageContactDetails.addContact.FixedLineOrMobileText']}</Message>}
								</FormGroup>
							</div>
						</div>

						<div className="row headerMargin">
							<div className="small-12 medium-12 large-12">
								<FormGroup>
									<Label>{messages['app.manageContactDetails.addContact.name']}</Label>
									<Dropdown
										fullWidth
										textID="person_name"
										testID='dropdown-person-list-test'
										defaultLabel={messages['app.manageContactDetails.addContact.namePlaceholder']}
										className="large-12 medium-12 small-12 full-width dropdownColor"
										size='large'
										selected={selectedPersonId}
										onChange={(personId) => this.changePerson(personId)}
										options={personDropdownValues}
									/>
									{!isPersonSelected && (<Message type="error"> {messages['app.manageContactDetails.addContact.personValidation.selectPerson']}</Message>)}
								</FormGroup>
							</div>
						</div>

						{/* FAX UI starts here */}
						<div className="headerMargin">
							<div className="row">
								<div className="small-12 medium-2 large-2">
									<FormGroup>
										<Label>{messages['app.manageContactDetails.addContact.fax']}</Label>
									</FormGroup>
								</div>
							</div>

							<div className="row">
								<div className="small-12 medium-5 large-5 column zeroLeftPadding">
									<FormGroup>
										<Dropdown
											className ='dropdownColor'
											fullWidth
											onChange={(e) => this.selectFaxCountry(e)}
											selected = {this.state.selectedFaxCountry}
											options={countryList}
										/>
										{!isValidFaxCountry && <Message type="error"> {messages['app.payments.dropdown.select']}</Message>}
									</FormGroup>
								</div>
								<div className="small-12 medium-7 large-7 column zeroRightPadding">
									<FormGroup>
										<TextInput
											textID="fax_no"
											testID='txt-fax-test'
											placeholder={messages['app.manageContactDetails.addContact.faxPlaceholder']}
											type="text"
											value={this.state.fax}
											onChange={(e) => this.saveFax(e)}
										/>
										{!isValidFax && (<Message type="error"> {messages['app.manageContactDetails.addContact.faxValidation.faxInvalid']} </Message>)}
									</FormGroup>
								</div>
							</div>
						</div>
						{/* FAX UI ends here */}

						<div className="row addContactBtnGroup">
							<Button 
							testID='btn-cancel-contact-details-test' 
							onClick={this.cancelAddContactDetail}>
							{messages['app.trade.label.cta.cancel']}</Button>
							<Button testID='btn-save-contact-details-test'
							disabled={isInputFieldsEmpty} 
							onClick={this.validateContactDetails}>
							{messages['app.profile.notification.saveButton']}</Button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default createContainer({
	$queries: {
		i18n: {
			messages: true,
		},
		hrmw: {
			setNewContactDetails: { $call: 'setNewContactDetails' },
			contactDetailsPersonData: true,
			latestContactDetails: true,
			setIsAddContactDetailsFlow: { $set: 'isAddContactDetailsFlow' },
		}
	},
})(AddContactDetails);